import { BONUSX_CMS_TOKEN, BONUSX_CMS_URL } from "../../constants/env";

export function getBonusxCmsConfig() {
  return {
    baseURL: BONUSX_CMS_URL || "",
    headers: { Authorization: `Bearer ${BONUSX_CMS_TOKEN}` },
  };
}
